"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var video_1 = require("./scripts/video");
var picture_1 = require("./scripts/picture");
var reel_1 = require("./scripts/reel");
var hitbox_1 = require("./scripts/hitbox");
var utils_1 = require("./scripts/utils");
(0, utils_1.setPlaceholders)();
var modal = document.getElementById("modal");
var openModalButton = document.getElementById("open-modal-btn");
var closeModalButton = document.getElementById("close-modal-btn");
openModalButton.addEventListener("click", function (e) {
    modal.style.display = "block";
});
closeModalButton.addEventListener("click", function (e) {
    modal.style.display = "none";
});
modal.addEventListener("click", function (e) {
    if (e.target == modal) {
        modal.style.display = "none";
    }
});
var videoWidth = 610;
var videoHeight = 469;
var multipleCaptureButton = document.getElementById('multi-capture-btn');
var pictureCount = document.getElementById('picture-count');
var countdownTimer = document.getElementById('countdown');
var flashElement = document.getElementById('flash');
//get all canvas elements with class of small-frame
var offpageCanvasArray = document.getElementsByClassName('offpage-frame');
var textarea = document.getElementById('caption');
var video = new video_1.default(videoWidth, videoHeight);
var stream = document.getElementById('video');
var reelDiv = document.getElementById('reel');
if (video.playing != true) {
    video.startVideo();
}
textarea.style.display = "none";
multipleCaptureButton.addEventListener('click', function (e) {
    //delay function that returns promise after x ms
    function delay(ms) {
        return new Promise(function (resolve) { return setTimeout(resolve, ms); });
    }
    //take as many photos as there are canvases on a delay of x ms
    function takePhotos() {
        return __awaiter(this, void 0, void 0, function () {
            var pCount, _loop_1, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        reelDiv.style.visibility = "hidden";
                        stream.style.visibility = "visible";
                        multipleCaptureButton.disabled = true;
                        textarea.style.display = "none";
                        pCount = 1;
                        pictureCount.innerText = "".concat(pCount, " / 4");
                        _loop_1 = function (i) {
                            var count, timer, offpageHolder;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        flashElement.style.visibility = 'hidden';
                                        flashElement.classList.remove('flash');
                                        count = 3;
                                        countdownTimer.innerText = count.toString();
                                        timer = setInterval(function () {
                                            count--;
                                            if (count < 1)
                                                count = 1;
                                            countdownTimer.innerText = count.toString();
                                        }, 1000);
                                        return [4 /*yield*/, (delay(3500))];
                                    case 1:
                                        _b.sent();
                                        flashElement.style.visibility = 'visible';
                                        flashElement.classList.add('flash');
                                        return [4 /*yield*/, (delay(500))];
                                    case 2:
                                        _b.sent();
                                        clearInterval(timer);
                                        pCount++;
                                        pictureCount.innerText = "".concat(pCount, " / 4");
                                        offpageHolder = new picture_1.default(stream, frames[i], videoWidth, videoHeight);
                                        offpageHolder.offpageCopy(offpageCanvasArray[i]);
                                        return [2 /*return*/];
                                }
                            });
                        };
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < offpageCanvasArray.length)) return [3 /*break*/, 4];
                        return [5 /*yield**/, _loop_1(i)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4:
                        textarea.style.display = 'block';
                        countdownTimer.innerText = "";
                        pictureCount.innerText = "";
                        flashElement.style.visibility = 'hidden';
                        flashElement.classList.remove('flash');
                        reelDiv.style.visibility = "visible";
                        reelDiv.style.zIndex = "0";
                        stream.style.visibility = "hidden";
                        multipleCaptureButton.disabled = false;
                        createReel();
                        return [2 /*return*/];
                }
            });
        });
    }
    if (video.playing)
        takePhotos();
});
//create reel - stop video first, then fill canvases 
var createReel = function () {
    var reel = new reel_1.default(offpageCanvasArray, videoWidth, videoHeight);
    reel.generateReel();
};
var frameList = document.getElementById('frame-list');
var backgroundCanvas = document.getElementById('background-canvas');
// const frame1 = document.getElementById('frame-list').firstChild;
var selectedFrame = document.getElementById('start-frame');
backgroundCanvas.width = 800;
backgroundCanvas.height = 650;
//load image and set background-canvas to image
var canvasContext = backgroundCanvas.getContext('2d');
// canvasContext.imageSmoothingEnabled = false;
var backgroundImage = new Image();
backgroundImage.src = "./assets/frame_".concat(selectedFrame.dataset.frame, ".png");
backgroundImage.onload = function () {
    canvasContext.drawImage(backgroundImage, 0, 0, 800, 650);
};
frameList.addEventListener('click', function (e) {
    //check if clicked element is an image
    var target = e.target;
    if (target.tagName === 'IMG') {
        if (selectedFrame) {
            selectedFrame.classList.remove('selected-frame');
        }
        target.classList.add('selected-frame');
        selectedFrame = target;
        backgroundCanvas.width = 800;
        backgroundCanvas.height = 650;
        //load image and set background-canvas to image
        var canvasContext_1 = backgroundCanvas.getContext('2d');
        // canvasContext.imageSmoothingEnabled = false;
        var backgroundImage_1 = new Image();
        backgroundImage_1.src = "./assets/frame_".concat(target.dataset.frame, ".png");
        backgroundImage_1.onload = function () {
            canvasContext_1.drawImage(backgroundImage_1, 0, 0, 800, 650);
        };
    }
});
var stickerList = document.getElementById('sticker-list');
var stickerCanvas = document.getElementById('sticker-canvas');
stickerCanvas.width = 800;
stickerCanvas.height = 525;
var stickerArray = [];
stickerList.addEventListener('click', function (e) {
    var target = e.target;
    var parentNode = target.parentNode;
    if (parentNode.tagName === 'LI') {
        var stickerType = target.dataset.type;
        var hitbox = new hitbox_1.default(stickerCanvas, stickerType);
        stickerArray.push(hitbox);
    }
});
var dragging;
stickerCanvas.addEventListener('mousedown', function (e) {
    var pos = getMousePos(stickerCanvas, e);
    var _loop_2 = function (i) {
        if (stickerArray[i].hit(pos.x, pos.y)) {
            var hitbox_2 = stickerArray[i];
            var context_1 = stickerCanvas.getContext('2d');
            dragging = (function (e) {
                pos = getMousePos(stickerCanvas, e);
                hitbox_2.posX = pos.x;
                hitbox_2.posY = pos.y;
                context_1.clearRect(0, 0, stickerCanvas.width, stickerCanvas.height);
                for (var j = 0; j < stickerArray.length; j++) {
                    stickerArray[j].drawSticker();
                }
            });
            stickerCanvas.addEventListener('mousemove', dragging);
            return "break";
        }
    };
    for (var i = 0; i < stickerArray.length; i++) {
        var state_1 = _loop_2(i);
        if (state_1 === "break")
            break;
    }
});
stickerCanvas.addEventListener('mouseup', function (e) {
    stickerCanvas.removeEventListener('mousemove', dragging);
});
function getMousePos(canvas, evt) {
    var rect = canvas.getBoundingClientRect();
    return {
        x: evt.clientX - rect.left,
        y: evt.clientY - rect.top
    };
}
var textColorSelect = document.getElementById('text-color-select');
var textFontSelect = document.getElementById('text-font-select');
var selectedColor = document.getElementById('selected-text-color');
textColorSelect.addEventListener('click', function (e) {
    var target = e.target;
    if (target.tagName === 'LI') {
        textarea.style.color = target.dataset.color;
    }
    if (selectedColor) {
        selectedColor.classList.remove('selected-text-color');
    }
    target.classList.add('selected-text-color');
    selectedColor = target;
});
var selectedFont = document.getElementById('selected-text-font');
textFontSelect.addEventListener('click', function (e) {
    var target = e.target;
    if (target.tagName === 'LI') {
        textarea.style.fontFamily = target.dataset.font;
        if (target.dataset.font === 'Sunspot') {
            textarea.style.fontSize = '36px';
            textarea.style.lineHeight = '0.9em';
        }
        else if (target.dataset.font === 'Pacifico') {
            textarea.style.fontSize = '32px';
            textarea.style.lineHeight = '1.3em';
        }
        else {
            textarea.style.fontSize = '28px';
            textarea.style.lineHeight = '1.3em';
        }
    }
    if (selectedFont) {
        selectedFont.classList.remove('selected-text-font');
    }
    target.classList.add('selected-text-font');
    selectedFont = target;
});
